import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function TermsOfService() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate('/')}
        sx={{ mb: 3 }}
      >
        Back to Home
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: March 20, 2024
        </Typography>

        <Box sx={{ '& > *': { mb: 3 } }}>
          <Typography variant="body1" paragraph>
            Please read these Terms of Service ("Terms") carefully before using the Richard Otieno for Teachers Union website and services.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using our website and services, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access our services.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            2. Use of Services
          </Typography>
          <Typography variant="body1" paragraph>
            Our services are intended for individuals who support our campaign for teachers' rights and education reform. You agree to use our services only for lawful purposes and in accordance with these Terms.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            3. User Conduct
          </Typography>
          <Typography variant="body1" paragraph>
            You agree not to:
          </Typography>
          <ul>
            <li>Use our services for any illegal purpose</li>
            <li>Harass, abuse, or harm others</li>
            <li>Submit false or misleading information</li>
            <li>Interfere with the proper functioning of our services</li>
            <li>Attempt to gain unauthorized access to our systems</li>
          </ul>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            4. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            All content on our website, including text, graphics, logos, and images, is the property of Richard Otieno for Teachers Union and is protected by Kenyan copyright laws.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            5. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            6. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms shall be governed by and construed in accordance with the laws of Kenya, without regard to its conflict of law provisions.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            7. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these Terms at any time. We will notify users of any changes by updating the "Last updated" date on this page.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            8. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For any questions about these Terms, please contact us at:
          </Typography>
          <Typography variant="body1">
            Email: legal@richardotieno.com<br />
            Phone: +254 XXX XXX XXX<br />
            Address: Nairobi, Kenya
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default TermsOfService; 